class StickyMarketingBar {
  constructor(element) {
    this.element = element;
    this.closeButton = element.querySelector(".sticky-marketing-bar__close");
    this.init();
  }

  init() {
    // Apparition avec délai
    const delay = parseInt(this.element.dataset.delay) || 2000;
    setTimeout(() => {
      this.show();
    }, delay);

    // Gestion du bouton de fermeture
    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.hide();
      });
    }
  }

  show() {
    this.element.classList.add("is-visible");
  }

  hide() {
    this.element.classList.remove("is-visible");
    this.element.style.display = "none";
  }
}

// Initialisation automatique
document.addEventListener("DOMContentLoaded", function () {
  const stickyBars = document.querySelectorAll(".sticky-marketing-bar");
  stickyBars.forEach((bar) => {
    new StickyMarketingBar(bar);
  });
});
